import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstPd1: [],
        pd1: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false
    },
    getters: {
        
    },
    mutations: {
        set(state, pd1){
            state.pd1 = pd1
            if (pd1)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
            state.pd1 = null
        },
        setParamsDataTable(state, payload){
            state.lstPd1 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
    },
    actions: {
        initForm(store){
            store.commit("initForm")
        },
        async find(store, { pd1codigo, pd1relat } ){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get(`/OryxPdv/PrintingPreferences/Find/${pd1codigo}/${pd1relat}`)
            .then(response => {
                let pd1 = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", pd1)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
        },
        save(store){
            if (store.state.update){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/OryxPdv/PrintingPreferences/Insert", store.state.pd1 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/preferencias-de-impressao")
                store.state.pd1 = null
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/OryxPdv/PrintingPreferences/Update", store.state.pd1 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/preferencias-de-impressao")
                store.state.pd1 = null
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete(`/OryxPdv/PrintingPreferences/Delete/${store.state.pd1.pd1codigo}/${store.state.pd1.pd1relat}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/preferencias-de-impressao")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async findList(store, pd1codigo){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get(`/OryxPdv/PrintingPreferences/FindList/${pd1codigo}`)
            .then(response => {
                let lstPd1 = Utils.ValidateAxiosResponse(response.data);
                store.state.lstPd1 = lstPd1
                store.state.hasNext = lstPd1.length > store.state.itemsPerPage
            }).catch(error => {
                store.state.lstPd1 = []
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            })
            store.state.loading = false
        },
        async search(store, { limit = 20, page = 1}){
            store.state.loading = true
            store.commit("initForm")
            let payload = await this._vm.$axios.get(`/OryxPdv/PrintingPreferences/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                store.commit("setParamsDataTable", payload)
                return true
            })
            .catch((error) => {
                store.state.lstPd1 = []
                store.state.search = ""
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.state.loading = false
            return payload
        },
    }
}